// Max width of centered page content - mirrors $container-max-width-xxl
export const CONTENT_MAX_WIDTH = "1258px";

// Bootstrap's `xl` breakpoint
export const NAV_WIDE_SPACING_MIN_WIDTH = "1200px";

// Bootstrap's `md` breakpoint
export const NARROW_SCREEN = "@media (max-width: 768px)";
